import { Component, ViewChild } from "@angular/core";
import { Nav, Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { UserServiceProvider } from "../providers/user-service/user-service";
import { AndroidFullScreen } from "@ionic-native/android-full-screen";

@Component({
  templateUrl: "app.html"
})
export class MyApp {
  private static instance: MyApp;

  @ViewChild(Nav) nav: Nav;

  // rootPage: any = Amis_001LoginPage;

  pages: Array<any>;

  public cb_user: any = {
    user_id: -1,
    userName: "",
    password: "",
    full_name: "",
    last_name: "",
    user_type: "",
    tokenID: "",
    is_logged: false,
    dummy_staff: 45
  };

  //var CB_PLATFORM = "LP";
  //CB_PLATFORM = "ZOO";
  //var CB_PLATFORM = "GENERALPOS";
  public static CB_PLATFORM = "ZOO";

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public userService: UserServiceProvider,
    private androidFullScreen: AndroidFullScreen
  ) {
    this.initializeApp();

    MyApp.instance = this;

    this.androidFullScreen
      .isImmersiveModeSupported()
      .then(() => this.androidFullScreen.immersiveMode())
      .catch(err => console.log(err));

    console.log(
      " ============================ Authenticate me  =================== "
    );
    console.log(window.localStorage.getItem("cb_user"));

    // var myUser: any = window.localStorage.getItem('cb_user');
    // if (myUser) {
    //   try {
    //     var tempObj = JSON.parse(myUser);
    //     console.log(tempObj.user_id);
    //     this.cb_user = tempObj;
    //     this.constructMainMenu();
    //   }
    //   catch (e) {
    //     alert("Not JSON YET" + e);
    //   }
    // }
  }

  constructMainMenu() {
    this.pages = this.userService.GetMenuForApp(MyApp.CB_PLATFORM);
  }

  static getInstance() {
    var cb_user = window.localStorage.getItem("cb_user");
    //console.log("Cb User");
    //console.log(cb_user);

    if (cb_user == null)
        cb_user = "";
    
    
    var appInstance = MyApp.instance;
    
    if (cb_user != "")
    {
      appInstance.cb_user = JSON.parse(cb_user);    
    }
   

    return appInstance;
  }

  openUpdateLink() {
    window.open("https://zoo.ciibos.com/assets/zoolive.apk");
  }
  
  initializeApp() {
    this.platform.ready().then(() => {
      console.log("Starting of everything");
      if (MyApp.getInstance().userService.getUserId() == -1) {
        this.nav.setRoot("Amis_001LoginPage");
      } else {
        console.log(MyApp.getInstance().userService.getUserId());
        this.nav.setRoot("Cb001HomepagePage");
      }
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    console.log("On Open Page");
    this.nav.push(page.navPath);
    console.log("end opene" + page.navPath);
  }

  logout() {
    console.log("Someone call logout");
    this.userService.logout();
    this.nav.setRoot("Amis_001LoginPage");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts